// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#privacy-policy ol>li{margin-top:10px}", "",{"version":3,"sources":["webpack://./resources/js/Pages/legal/PrivacyPolicy.vue"],"names":[],"mappings":"AAGY,sBACI,eAFhB","sourcesContent":["\n    #privacy-policy {\n        ol {\n            & > li {\n                margin-top: 10px;\n            }\n        }\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
